import { IS_LOCAL_ENV } from "../App";
import { _axios } from "./config";
import qs from "qs";

export const getInitialMessage = async () => {
  try { //solo debe haber 1
    const { data } = await _axios.get("/api/initialMessage");
    return data;
  } catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
};

export const updateInitialMessage = async (props) => {

  const stringifiedQuery = qs.stringify({
    where: {
      createdAt: {
        greater_than: "2025-01-01"
      }
    }
  }, {
    addQueryPrefix: true
  });

  try {
    const { data } = await _axios.patch(`/api/initialMessage${stringifiedQuery}`, props);
    return data;
  } catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
};


export const getBanners = async () => {
  try {
    const { data } = await _axios.get("/api/banners?limit=0");
    return data;
  } catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
};

export const deleteBannerImage = async (id) => {
  try {
    const { data } = await _axios.delete(`/api/bannerPhotos/${id}`);
    return data;
  } catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
};

export const uploadBannerImage = async (props) => {
  //form
  const formData = new FormData();
  formData.append("alt", props.alt);
  formData.append("file", props.file);

  try {
    const { data } = await _axios.post("/api/bannerPhotos", formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    });
    return data;
  } catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
};

export const updateBanner = async (id, props) => {
  try {
    const { data } = await _axios.patch(`/api/banners/${id}`, props);
    return data;
  } catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
};

export const createBanner = async (props) => {
  try {
    const { data } = await _axios.post("/api/banners", props);
    return data;
  } catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
};

export const deleteBanner = async (id) => {
  try {
    const { data } = await _axios.delete(`/api/banners/${id}`);
    return data;
  } catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
};

export const getIgPosts = async () => { //ig posts
  try {
    const { data } = await _axios.get("/api/igPosts");
    return data;
  } catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
};

export const updateIgPost = async (id, props) => {
  try {
    const { data } = await _axios.patch(`/api/igPosts/${id}`, props);
    return data;
  } catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
};

export const createIgPost = async (props) => {
  try {
    const { data } = await _axios.post("/api/igPosts", props);
    return data;
  } catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
};

export const deleteIgPost = async (id) => {
  try {
    const { data } = await _axios.delete(`/api/igPosts/${id}`);
    return data;
  } catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
};

export const getPosts = async () => {
  try {
    const { data } = await _axios.get(`/api/posts`);
    return data;
  }
  catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
}

export const createPost = async (props) => {
  try {
    const { data } = await _axios.post("/api/posts", props);
    return data;
  } catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
};

export const updatePost = async (id, props) => {
  try {
    const { data } = await _axios.patch(`/api/posts/${id}`, props);
    return data;
  } catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
};

export const deletePost = async (id) => {
  try {
    const { data } = await _axios.delete(`/api/posts/${id}`);
    return data;
  } catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
};

export const uploadPostImage = async (props) => {
  //form
  const formData = new FormData();
  formData.append("alt", props.alt);
  formData.append("file", props.file);

  try {
    const { data } = await _axios.post("/api/postPhotos", formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    });
    return data;
  } catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
};

export const deletePostImage = async (id) => {
  try {
    const { data } = await _axios.delete(`/api/postPhotos/${id}`);
    return data;
  } catch (err) {
    IS_LOCAL_ENV && console.error(err);
    throw err;
  }
};